<template>
  <v-expansion-panels flat>
    <v-expansion-panel class="grey lighten-4">
      <v-expansion-panel-header class="pl-4 pt-0 pb-0">
        <v-list-item class="pl-0" dense>          
          <v-list-item-avatar v-if="
            !ver_detalhes &&
            cargaSelec.pode_editar &&
            cargaSelec.dist_caixas.filter(
              (c) =>
                c.caixa > 0 && c.pedido.cod_pedido == pedido.pedido.cod_pedido
            ) == 0
          ">
            <v-btn icon color="error"
              @click="cargaSelec.dist_caixas.splice(pos, 1)"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
          </v-list-item-avatar>
          <v-list-item-content>

            <v-list-item-title class="font-weight-bold">{{
              pedido.pedido.nome_cliente
            }}</v-list-item-title>
            <v-list-item-subtitle>{{
              pedido.pedido.cidade_entrega
            }}</v-list-item-subtitle>
            <v-list-item-subtitle v-if="$mq == 'sm'">
              <span class="font-weight-bold teal--text">{{ pedido.qtde }} Kgs</span>
            </v-list-item-subtitle>
            <v-list-item-subtitle class="mt-1 subtitle-2">
              Pedido <span class="title font-weight-bold">{{ pedido.pedido.nr_pedido }}</span>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action v-if="$mq != 'sm'">
            <span class="font-weight-bold teal--text">{{ pedido.qtde }} Kgs
            </span>
          </v-list-item-action>
          <v-badge v-if="
            cargaSelec &&
            cargaSelec.permite_programar_carga &&
            cargaSelec.carga_programada
          " offset-x="-45" offset-y="-16" color="success" bordered icon="
            mdi-check
            "></v-badge>
        </v-list-item>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-data-table hide-default-footer no-data-text="Nenhum item encontrado" :items="pedido.pedido.itens"
          :headers="headers" dense disable-sort class="itens-ped-carga">
          <template v-slot:[`item.produto`]="{ item }">
            <span>{{ item.produto }} {{ item.embalagem }}
              <small>
                ({{ item.gp }}-{{ item.sgp }}-{{ item.item }})</small></span>
          </template>
          <template v-slot:[`item.qtde_kgs`]="{ item }">
            <span>{{ item.qtde_kgs }} Kgs</span>
          </template>
        </v-data-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    pos: { type: Number, required: true },
    pedido: { type: Object, required: true },
  },
  computed: mapState("formacaoCarga", ["cargaSelec", "ver_detalhes"]),
  data: () => ({
    headers: [
      { text: "Produto", value: "produto", align: "start" },
      { text: "Qtde(kgs)", value: "qtde_kgs", align: "start" },
    ],
  }),
};
</script>

<style>
.v-data-table.itens-ped-carga>.v-data-table__wrapper>table>tbody>tr>td {
  font-size: 0.78rem !important;
}
</style>